export const getPerfilColor = (perfilNome: string): { backgroundColor: string; color: string } => {
  const colors: { [key: string]: { backgroundColor: string; color: string } } = {
    'ADM': { backgroundColor: '#dc3545', color: '#fff' },
    'DEDH': { backgroundColor: '#fd7e14', color: '#fff' },
    'Técnico': { backgroundColor: '#6f42c1', color: '#fff' },
    'Secretário': { backgroundColor: '#20c997', color: '#fff' },
    'Presidente': { backgroundColor: '#0d6efd', color: '#fff' },
    'Membro': { backgroundColor: '#198754', color: '#fff' },
    'Suplente': { backgroundColor: '#6c757d', color: '#fff' },
    'INTEGRACAO': { backgroundColor: '#495057', color: '#fff' },
    'sem perfil': { backgroundColor: '#f8f9fa', color: '#6c757d' }
  };

  return colors[perfilNome] || { backgroundColor: '#e9ecef', color: '#495057' };
};